<template>
  <a-card :bordered="false">
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="12">
              <a-form-item label="选择渠道">
                <a-select
                  v-model="wechatAppId"
                  placeholder="请选择渠道"
                  style="width: 200px;margin-left: auto"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="item in channelList"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="mod-config">
        <a-form-model
          layout="inline"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
        >
          <a-form-model-item>
            <a-input
              v-model="dataForm.matchValue"
              placeholder="匹配关键词"
              clearable
            ></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getDataList()">查询</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="table-operator">
          <a-button @click="addOrUpdateHandle()" type="primary" icon="plus"
            >新增</a-button
          >

          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="onDelete()">
                <a-icon type="delete" />批量删除</a-menu-item
              >
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
            >项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>
          <a-table
            :columns="columns"
            :data-source="dataList"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
            bordered
            rowKey="id"
            :pagination="ipagination"
            @change="handleTableChange"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="addOrUpdateHandle(record.id)">修改</a>
              <a-divider type="vertical" />

              <a href="javascript:;" @click="onDelete(record.id)">删除</a>
            </span>
          </a-table>
        </div>

        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
          @refreshDataList="getDataList"
          :wechatAppId="this.wechatAppId"
        ></add-or-update>
      </div>
    </div>
  </a-card>
</template>

<script>
import { mapState } from 'vuex';
import channelSearch from '../weChatSearch.vue';
import { getAction, postTag } from '@/api/manage';
import AddOrUpdate from './modules/editModal.vue';
export default {
  components: {},
  data() {
    return {
      wechatType: '1,2',
      channelList: [],
      dataForm: {
        matchValue: ''
      },
      selectedRowKeys: [],

      wechatAppId: '',
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      dataListLoading: false,
      selectedRowKeys: [],
      addOrUpdateVisible: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          title: '规则名称',
          dataIndex: 'ruleName',
          key: 'ruleName'
        },
        {
          title: '匹配关键词',
          dataIndex: 'matchValue',
          key: 'matchValue'
        },
        {
          title: '消息类型',
          dataIndex: 'replyType',
          key: 'replyType'
        },
        {
          title: '回复内容',
          dataIndex: 'replyContent',
          key: 'replyContent',
          width: 200,
          ellipsis: true
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  computed: mapState({
    KefuMsgType: state => state.message.KefuMsgType
  }),
  components: {
    channelSearch,
    AddOrUpdate
  },
  mounted() {
    this.getChannelAll();
  },
  methods: {
    handleChange(item) {
      //渠道下拉框选择
      // console.log(item);

      this.wechatAppId = item;
      this.getDataList();
    },
    getChannelAll() {
      getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryAll', {
        type: this.wechatType
      }).then(res => {
        if (res.success) {
          this.wechatAppId = res.result[0].code;
          this.channelList = res.result;
          this.$nextTick(() => {
            this.getDataList();
          });
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    test(data) {
      this.wechatAppId = data;
      this.getDataList();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    handleTableChange(pagination) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initProductList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/msgReplyRule/list', {
        appId: this.wechatAppId,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        matchValue: this.dataForm.matchValue
      }).then(res => {
        if (res.success && res.code === 200) {
          this.dataList = res.result.records;
          this.ipagination.total = res.result.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    onDelete(id) {
      let that = this;
      const dataSource = [...this.dataList];
      let ids = id ? [id] : this.selectedRowKeys;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          postTag(
            process.env.VUE_APP_CMS_WECHAT + '/manage/msgReplyRule/delete',
            ids
          ).then(res => {
            if (res.success && res.code === 200) {
              that.$message.success('操作成功');
              that.dataList = dataSource.filter(item => item.id !== id);
              that.getDataList();
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    replyTypeFormat(row, column, cellValue) {
      return this.KefuMsgType[cellValue];
    }
  }
};
</script>
<style scoped>
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.table-operator {
  margin-bottom: 10px;
}
</style>
